// export const API_BASE="https://admin.mym-b.com:8443"
export const API_MANAGER_LOGIN =  "/login"
export const API_MANAGER_CRATE =  "/api/manager"
export const API_MANAGER_GET_ALL =  "/api/manager/all";
export const API_MANAGER_GET_BY_ID =  "/api/manager";
export const API_MANAGER_UPDATE_TYPE =  "/api/manager/super/type";
export const API_MANAGER_RESET_PASSWORD =  "/api/manager/super/password";
export const API_MANAGER_CHANGE_PASSWORD =  "/api/manager"
export const API_MANAGER_DELETE = "/api/manager";